import {createContext, useContext} from 'react';

type CustomGroupItemContextType = {
    inputId?: string,
};

const DEFAULT_CONTEXT = {
    inputId: undefined,
};

export const CustomGroupItemContext = createContext<CustomGroupItemContextType>(DEFAULT_CONTEXT);
CustomGroupItemContext.displayName = 'CustomGroupItemContext';

export const useCustomGroupItemContext = () => useContext(CustomGroupItemContext);
